<template>
  <FormulateForm
    id="contact"
    v-model="formData"
    method="post"
    @submit="submitHandler()"
  >
    <FormulateInput
      name="bonusCode"
      type="text"
      label="bonus code"
      validation="nohtml"
      class="custom-form-element"
      aria-hidden="true"
    />
    <FormulateInput
      name="website"
      type="text"
      :label="i18n.form.labels.website"
      validation="nohtml"
      class="custom-form-element"
      aria-hidden="true"
    />

    <!-- Umbraco / infra -->
    <FormulateInput
      type="hidden"
      name="formToken"
      :value="formToken"
    />
    
    <FormulateInput
      type="hidden"
      name="__RequestVerificationToken"
    />

    <FormulateInput
      type="hidden"
      name="ufprt"
    />

    <FormulateInput
      type="hidden"
      name="label"
      :value="label"
    />
    <FormulateInput
      type="hidden"
      name="sublabel"
    />
    <FormulateInput
      type="hidden"
      name="locale"
      :value="locale"
    />

    <FormulateInput
      :label="i18n.form.labels.name"
      name="name"
      validation="bail|required:trim|nohtml"
      :validation-messages="i18n.form.validations.name"
    />

    <FormulateInput
      name="email"
      type="email"
      :label="i18n.form.labels.email"
      validation="bail|required:trim|email"
      :validation-messages="i18n.form.validations.email"
    />

    <FormulateInput
      name="phonenumber"
      type="text"
      :label="i18n.form.labels.phonenumber"
      :validation="[formData.callbackCheckbox ? 'required' : null, 'nohtml']"
      :validation-messages="i18n.form.validations.phonenumber"
    />

    <FormulateInput
      name="childname"
      :label="i18n.form.labels.childname"
      validation="nohtml"
      :validation-messages="i18n.form.validations.childname"
    />

    <FormulateInput
      v-show="!isAboutFieldPreselected"
      type="select"
      name="about"
      :options="i18n.form.options.about"
      :label="i18n.form.labels.about"
      validation="required"
      :validation-messages="i18n.form.validations.about"
      error-behavior="blur"
    />

    <FormulateInput
      name="remark"
      type="textarea"
      :label="i18n.form.labels.remark"
      validation="bail|required:trim|nohtml"
      :validation-messages="i18n.form.validations.remark"
    />

    <fields-control-buttons
      :is-loading="isLoading"
      :i18n="i18n"
      @previous="previousHandler"
    />
  </FormulateForm>
</template>

<script>
import FieldsControlButtons from '@/components/forms/fields/FieldsControlButtons.vue';
import UmbracoFormMixin from '@/mixins/UmbracoForm';

export default {
  name: 'FormContact',
  components: {
    FieldsControlButtons,
  },
  mixins: [UmbracoFormMixin],
  props: {
    uForm: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Partou',
    },
    i18n: {
      type: Object,
      default: null,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    locale: {
      type: String,
      default: null,
    },
    subjectValueForComplaints: {
      type: String,
      default: null,
    },
    formToken: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      callbackIsChecked: null,
      isLoading: false,
      formData: this.data,
      isAboutFieldPreselected: false,
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('sublabel')) {
      this.formData.sublabel = decodeURIComponent(urlParams.get('sublabel'));
    }

    if (urlParams.has('about')) {
      const about = decodeURIComponent(urlParams.get('about'));

      if (this.i18n.form.options.about[about]) {
        this.formData.about = about;
        this.isAboutFieldPreselected = true;
      }
    }
  },
  methods: {
    async submitHandler() {
      this.isLoading = true;
      this.$el.submit();
    },
    previousHandler() {
      window.history.go(-1);
    },
  },
};
</script>
